/**
 * RP74 (D31) — réglage du chantier « le client voit les montants ».
 * Source : GET /api/chantiers/{cid}/reglages-client.
 *
 *   const { reglage, loading, refresh } = useReglagesClient(chantierId, enabled);
 *   reglage = { client_voit_montants, par_defaut, personnalise, modifiable } | null
 *
 * `enabled = false` : aucun appel (rôles qui n'en ont pas besoin).
 */
import { useCallback, useEffect, useState } from 'react';
import axios from 'axios';

const API_URL = process.env.REACT_APP_BACKEND_URL;

export default function useReglagesClient(chantierId, enabled = true) {
  const [reglage, setReglage] = useState(null);
  const [loading, setLoading] = useState(false);

  const refresh = useCallback(async () => {
    if (!chantierId || !enabled) return;
    setLoading(true);
    try {
      const { data } = await axios.get(`${API_URL}/api/chantiers/${chantierId}/reglages-client`, { withCredentials: true });
      setReglage(data);
    } catch {
      setReglage(null);
    } finally {
      setLoading(false);
    }
  }, [chantierId, enabled]);

  useEffect(() => { refresh(); }, [refresh]);

  return { reglage, setReglage, loading, refresh };
}
